import { MatSnackBar } from '@angular/material/snack-bar';
import { Component, OnInit, OnDestroy, ViewChild, Inject } from "@angular/core";
import { MAT_BOTTOM_SHEET_DATA } from "@angular/material/bottom-sheet";
import { Store } from "@ngrx/store";
import { IPageData } from "../../../interfaces/page-data";
import { IAppState } from "../../../interfaces/app-state";
import { HttpService } from "../../../services/http/http.service";
import * as PageActions from "../../../store/actions/page.actions";
import { Options } from "ng5-slider";
import Swal from "sweetalert2";
import swal from "sweetalert2";
import { HttpErrorResponse } from "@angular/common/http";
import {
  MatBottomSheet,
  MatBottomSheetRef,
} from "@angular/material/bottom-sheet";
import { Subject } from "rxjs";
import { ActivatedRoute, Router } from "@angular/router";
import { Spinkit } from "ng-http-loader"; // <============
import { Location } from "@angular/common";
import { BasePageComponent } from "../../base-page";
import { environment } from "src/environments/environment";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
@Component({
  selector: "app-profile",
  templateUrl: "./profile.component.html",
  styleUrls: ["./profile.component.scss"],
})
export class ProfileComponent
  extends BasePageComponent
  implements OnInit, OnDestroy {
  pageData: IPageData;
  value: number = 0;
  public spinkit = Spinkit;
  restoID;
  ids;
  UserCondition;
  user_details;
  token;
  tableids;
  taste_id;
  taste_code;
  taste_totalScore;
  expiry;
  id;
  userName;
  encodeid;
  encodeexpiry;
  tokenCheck;
  decodetoken;
  encodedJwtJsonData;
  defalutimage = "./assets/img/PngItem_1503945.png";
  userdatails_array = [];
  public totalSubject = new Subject();
  public orderSubject = new Subject();
  userName_loggedin: string;
  lengthallergens: any;
  crossC;
  female = "./assets/img/female.png";
  male = "./assets/img/male.png";
  lengthdietary: any;
  user_Name: string[];
  imageFile: FormData;
  messageFilesize: string;
  currentAvatar: string | ArrayBuffer;
  errorMessage: any;
  editCondition = false
  src: string 
  temp: any
  editFirstName: string
  editLastName: string
  editTasteId: string
  editEmail: string
  editPhone: string
  editAddress: string
  imgFlag:boolean
  constructor(
    store: Store<IAppState>,
    public httpSv: HttpService,
    private router: Router,
    private route: ActivatedRoute,
    private _bottomSheet: MatBottomSheet,
    public dialog: MatDialog,
    private _location: Location,
    private _snackBar: MatSnackBar
  ) {
    super(store, httpSv);

    this.pageData = {
      title: "",
      loaded: true,
      breadcrumbs: [
        {
          title: "",
          route: "profile",
        },
      ],
    };
  }
  userEmail;
  referalcode: any;
  Baselinkshare: any
  sendErrorMessage: any
  ngOnInit() {
    this.restoID = sessionStorage.getItem("restoId");
    this.token = sessionStorage.getItem("access_token");
    this.userEmail = sessionStorage.getItem("email");
    this.ids = sessionStorage.getItem("restoIds");
    this.tableids = sessionStorage.getItem("tableIds");
    this.route.queryParams.subscribe((params) => {
      this.UserCondition = sessionStorage.getItem("access_token") ? true : false;
    });
    this.pageData
      ? this.store.dispatch(new PageActions.Set(this.pageData))
      : null;
    if (this.UserCondition) {
      this.userName_loggedin = sessionStorage.getItem("userName");
      this.user_Name = this.userName_loggedin.split(" ");
      this.userName = this.user_Name[0];
      this.userProfile();
      this.tasteDetailsget();
    }
    this.encodedJwtJsonData = btoa(this.token);
    this.getUserDetails()
    this.httpSv.shareCodeGet().subscribe(res => {
      if (res['status'] == true) {
        this.referalcode = btoa(res['result'].data)
        this.Baselinkshare = environment.sharelinkUrldecode + this.referalcode
      }
    }, (err: HttpErrorResponse) => {
      this.sendErrorMessage = err.error.message;
      if (err.status == 401) {
        this.logout();
      }
      else if (err.status == 500) {
        this.logout();
      }
    })
  }

  ngOnDestroy() {
    this.store.dispatch(new PageActions.Reset());
  }
  backTologin() {
    this.router.navigate(["/public/sign-in"]);
    sessionStorage.setItem("guestTouserProfile", "true");
  }
  backHomeUser() {
    this.router.navigate(["/horizontal/resto"]);
  }
  backHomeGuest() {
    this.router.navigate(["/public/resto"]);
  }
  logout() {
    const dialogRef = this.dialog.open(LogoutDialog, {
      width: "250px",
      height: "100px",
    });

    dialogRef.afterClosed().subscribe((result) => { });
    // this.httpSv.logouts(this.token).subscribe(
    //   response => {
    //     if (response['status'] == true) {
    //       sessionStorage.clear();
    //       this.router.navigate(['/public/resto'], {
    //         // queryParams: {
    //         //   id: this.ids,
    //         //   table_id: this.tableids
    //         // }
    //       });
    //     } else {
    //       Swal.fire("Something Went Wrong")
    //     }
    //   }
    // )
  }

  goToPreference() {
    this.router.navigate(["/horizontal/preference"]);
  }
  OnEditclick() {
    this.router.navigate(["/horizontal/edit-profile"]);
  }

  backClicked() {
    this.router.navigate(["/horizontal/food-menu"]);
  }
  userProfile() {
    this.httpSv.userProfile().subscribe(
      (response) => {
        if (response["status"] == true) {
          this.userdatails_array = []
          this.imgFlag = true
          this.user_details = response["result"];
          this.userdatails_array.push(this.user_details);
          this.temp = response["result"]
          if (this.temp['up_profile_image']) {
            this.src = this.temp['up_profile_image']
          } else this.src = this.defalutimage
          if (this.user_details.userAllergens) {
            this.lengthallergens = this.user_details.userAllergens.length;
          }
          if (this.user_details.userDietary) {
            this.lengthdietary = this.user_details.userDietary.length;
          }
        }
      },
      (err: HttpErrorResponse) => {
        // this.logout();
        this.imgFlag = false
        this.getUserAllDeatailsFromOther()
        if (err.status == 401) {
          // this.logout();
        } else if (err.status == 500) {
          this.logout();
        }
      }
    );
  }

  count(j) {
    let spicevar = [];
    for (let i = 0; i < j; i++) {
      spicevar.push(j);
    }
    return spicevar;
  }
  tasteDetailsget() {
    this.httpSv.tasteDetailsget().subscribe(
      (res) => {
        if (res["status"] == true) {
          this.taste_id = res["result"].data.tc_id;
          this.taste_code = res["result"].data.tc_code;
          this.taste_totalScore = res["result"].data.totalScore;
        }
      },
      (err: HttpErrorResponse) => {
        if (err.status == 401) {
          this.logout();
        } else if (err.status == 500) {
          this.logout();
        }
      }
    );
  }

  crossCon(value) {
    if (value == true) {
      this.crossC = "Yes";
    } else this.crossC = "No";
    const data = {
      status: this.crossC,
    };
    sessionStorage.setItem("UserCC", this.crossC);
    this.httpSv.updateUserPreference(data).subscribe((response) => {
      if (response["status"] == true) {
      } else {
        Swal.fire("Something Went Wrong");
      }
    });
  }

  tasteidgenerate() {
    window.open(environment.quizlinkUrl + "?id=" + this.encodedJwtJsonData);
  }
  onDetails() {
    sessionStorage.setItem("Details", "true");
    sessionStorage.removeItem("preferences");
  }
  onPreferences() {
    sessionStorage.setItem("preferences", "true");
    sessionStorage.removeItem("Details");
  }

  onClickallergen() {
    this._bottomSheet.open(BottomSheetOverviewpreference, {});
  }

  onClickdietary() {
    this._bottomSheet.open(BottomSheetOverviewdietary, {});
  }

  fileChange(event) {
    let fileList: FileList = event.target.files;
  }

  onImageChange(event) {
    if (event.target.files && event.target.files[0]) {
      const fsize = event.target.files[0].size;
      const fileSize = Math.round(fsize / 1024);
      if (fileSize < 2048) {
        this.imageFile = new FormData();
        this.imageFile.append("file", event.target.files[0]);
        let file: File = event.target.files[0];
        let reader: FileReader = new FileReader();
        this.messageFilesize = "";
        reader.onload = (e: any) => {
          this.src = e.target.result;
        };
        reader.onloadend = () => {
          this.currentAvatar = reader.result;
        };
        reader.readAsDataURL(file);
        this.uploadImage();
      } else {
        this.messageFilesize =
          "File too Big, please select a file less than 2mb";
      }
    }
    // let file: File = event.target.files[0];
    // let reader: FileReader = new FileReader();
    // reader.readAsDataURL(event.target.files[0]);


  }

  uploadImage() {
    this.httpSv.updateuserImage(this.imageFile).subscribe(
      (response) => {
        if (response["status"] == true) {
          // this.router
          //   .navigateByUrl("/RefreshComponent", { skipLocationChange: true })
          //   .then(() => {
          //     this.router.navigate(["horizontal/profile"]);
          //   });
          this._snackBar.open('Image changed successfully')
          this.userProfile()
          setTimeout(() => {
            this._snackBar.dismiss()
          }, 2000)
        }
      },
      (err: HttpErrorResponse) => {
        this.errorMessage = err.error.message;
        if (err.status == 401) {
          this.logout();
          swal.fire({
            titleText: this.errorMessage,
            timer: 2000,
            showCancelButton: false,
            showConfirmButton: false,
            position: "top-right",
          });
        } else if (err.status == 500) {
          this.logout();
          swal.fire({
            titleText: this.errorMessage,
            timer: 2000,
            showCancelButton: false,
            showConfirmButton: false,
            position: "top-right",
          });
        }
      }
    );
  }
  myOrder() {
    this.router.navigate(['/horizontal/myOrders'])
  }
  editProfle() {
    this.editCondition = !this.editCondition
  }
  updateUserProfile() {
    const data = new FormData()
    data.append('fname', this.editFirstName)
    data.append('lname', this.editLastName)
    data.append('phone', this.editPhone)
    data.append('address', this.editAddress)
    this.httpSv.updateUsersProfileDeatails(data).subscribe(res => {
      if (res['status'] == 'TRUE') {
        this._snackBar.open('Profile Updated')
        sessionStorage.setItem('userName', this.editFirstName)
        this.userName_loggedin = sessionStorage.getItem('userName')
        this.getUserDetails()
        this.editProfle()
        setTimeout(() => {
          this._snackBar.dismiss()
        }, 2000);
      }
    })
  }
  myFreind() {
    if(this.taste_code){
    this.router.navigate(['horizontal/friends'])
    }else{
      this._snackBar.open('Please create taste ID to connect with friends!!')
      setTimeout(()=>{
        this._snackBar.dismiss()
      },2000)
    }
  }
  getUserDetails() {
    this.httpSv.getUserAllDeatails().subscribe(res => {
      if (res['status'] == true) {
        let temp = res['result']
        this.editFirstName = temp.up_fname
        this.editLastName = temp.up_lname
        this.editEmail = temp.email
        this.editPhone = temp.up_phone
        this.editAddress = temp.up_address
      }
    })
  }
  getUserAllDeatailsFromOther(){
    this.httpSv.getUserAllDeatailsFromOther().subscribe(res => {
      if (res['status'] == true) {
        let temp = res['result']
        this.editFirstName = temp.up_fname
        this.editLastName = temp.up_lname
        this.editEmail = temp.email
        this.editPhone = temp.up_phone
        this.editAddress = temp.up_address
      }
    })
  }
  shareFrnFunc() {
    this._bottomSheet.open(ShareLinkWithFreind, {
      data: {
        referalcode: this.referalcode,
        baseLink: this.Baselinkshare
      }
    })
  }
}

@Component({
  selector: "bottom-sheet-overview-preference",
  templateUrl: "bottom-sheet-overview-preference.html",
})
export class BottomSheetOverviewpreference implements OnInit {
  user_details: any;
  userdatails_array = [];
  ids: any;
  token;
  allgens_id;
  Ingredient_id;
  tableids: any;
  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    private bottomSheetRef: MatBottomSheetRef<BottomSheetOverviewpreference>,
    private router: Router,
    public httpSv: HttpService
  ) { }

  ngOnInit() {
    this.token = sessionStorage.getItem("access_token");
    this.userProfile();
  }

  logout() {
    this.httpSv.logouts(this.token).subscribe((response) => {
      if (response["status"] == true) {
        sessionStorage.clear();
        window.location.reload();
        this.router.navigate(["public/resto"], {
          queryParams: {
            id: this.ids,
            table_id: this.tableids,
          },
        });
      } else {
        Swal.fire("Something Went Wrong");
      }
    });
  }

  userProfile() {
    this.httpSv.userProfile().subscribe(
      (response) => {
        if (response["status"] == true) {
          this.user_details = response["result"];
          this.userdatails_array.push(this.user_details);
        }
      },
      (err: HttpErrorResponse) => {
        this.logout();
        if (err.status == 401) {
          this.logout();
        } else if (err.status == 500) {
          this.logout();
        }
      }
    );
  }
}

@Component({
  selector: "bottom-sheet-overview-dietary",
  templateUrl: "bottom-sheet-overview-dietary.html",
})
export class BottomSheetOverviewdietary implements OnInit {
  user_details: any;
  userdatails_array = [];
  ids: any;
  token;
  userdislike_id;
  dietary_id;
  tableids: any;
  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    private bottomSheetRef: MatBottomSheetRef<BottomSheetOverviewdietary>,
    private router: Router,
    public httpSv: HttpService
  ) { }
  ngOnInit() {
    this.userProfile();
  }
  logout() {
    this.httpSv.logouts(this.token).subscribe((response) => {
      if (response["status"] == true) {
        sessionStorage.clear();
        window.location.reload();
        this.router.navigate(["public/resto"], {
          queryParams: {
            id: this.ids,
            table_id: this.tableids,
          },
        });
      } else {
        Swal.fire("Something Went Wrong");
      }
    });
  }

  userProfile() {
    this.httpSv.userProfile().subscribe(
      (response) => {
        if (response["status"] == true) {
          this.user_details = response["result"];
          this.userdatails_array.push(this.user_details);
        }
      },
      (err: HttpErrorResponse) => {
        if (err.status == 401) {
          this.logout();
        } else if (err.status == 500) {
          this.logout();
        }
      }
    );
  }
}


@Component({
  selector: "logout-dialog",
  templateUrl: "logout-dialog.html",
})
export class LogoutDialog implements OnInit {
  token;
  constructor(
    public dialogRef: MatDialogRef<LogoutDialog>,
    public httpSv: HttpService,
    @Inject(MAT_DIALOG_DATA) public data,
    private router: Router
  ) { }
  ngOnInit(): void {
    this.token = sessionStorage.getItem("access_token");
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  logout() {
    this.dialogRef.close();
    sessionStorage.clear();
    this.router.navigate(["/public/resto"]);
    window.location.reload();
    // this.httpSv.logouts(this.token).subscribe(
    //   response => {
    //     if (response['status'] == true) {
    //       sessionStorage.clear();
    //       this.router.navigate(['/public/resto'], {
    //       });
    //     } else {
    //       Swal.fire("Something Went Wrong")
    //     }
    //   }
    // )
  }
}
@Component({
  selector: "share-with-freind",
  templateUrl: "share-with-friend.html",
})
export class ShareLinkWithFreind implements OnInit {
  constructor(
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    private bottomSheetRef: MatBottomSheetRef<ShareLinkWithFreind>,
    private router: Router,
    public httpSv: HttpService
  ) { }
  ngOnInit(): void {
    this.referCode = this.data.referalcode
    this.baseLinkCode = this.data.baseLink
  }
  referCode: any
  baseLinkCode: any
  onclickFb(){
    let Baselink = environment.sharelinkUrlFb + this.referCode 
    window.location.href = Baselink
  }
  onclickwhatapp(){
    let Baselink = environment.sharelinkUrlwhatapp + this.referCode 
    window.location.href = Baselink

  }
  onclickTwitter(){
    let Baselink = environment.sharelinkUrltwitter + this.referCode 
    window.location.href = Baselink

  }
}